import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

const Schema = yup.object().shape(
  {
    currency: yup.string().required('This field is required'),
    description: yup
      .string()
      .notRequired()
      .nullable()
      .when('description', {
        is: (value: string) => value?.length,
        then: (rule) =>
          rule
            .min(5, 'Must have from 5 to 50 characters')
            .max(50, 'Must have from 5 to 50 characters')
            // eslint-disable-next-line
            .test('isLatinLetters', 'Latin letters, and numbers only', (value: any): boolean =>
              /^[a-zA-Z0-9!@#$%^&*\s()_+\-=[\]{};':"\\|,.<>/?]*$/.test(value),
            ),
      }),
    beneficiaryName: yup
      .string()
      .required('This field is required')
      .min(2, 'Must have at least 2 characters')
      // eslint-disable-next-line
      .test('isLatinLetters', 'Latin letters, and numbers only', (value: any): boolean =>
        /^[a-zA-Z0-9!@#$%^&*\s()_+\-=[\]{};':"\\|,.<>/?]*$/.test(value),
      ),
    bankBranchName: yup
      .string()
      .required('This field is required')
      .min(2, 'Must have at least 2 characters')
      // eslint-disable-next-line
      .test('isLatinLetters', 'Latin letters, and numbers only', (value: any): boolean =>
        /^[a-zA-Z0-9!@#$%^&*\s()_+\-=[\]{};':"\\|,.<>/?]*$/.test(value),
      ),
    bankAddress: yup
      .string()
      .required('This field is required')
      .min(2, 'Must have at least 2 characters')
      // eslint-disable-next-line
      .test('isLatinLetters', 'Latin letters, and numbers only', (value: any): boolean =>
        /^[a-zA-Z0-9!@#$%^&*\s()_+\-=[\]{};':"\\|,.<>/?]*$/.test(value),
      ),
    bankSwiftBic: yup
      .string()
      .required('This field is required')
      .min(8, 'Must have 8-11 characters')
      .max(11, 'Must have 8-11 characters')
      // eslint-disable-next-line
      .test('isLatinLetters', 'Latin letters, and numbers only', (value: any): boolean => /^[a-zA-Z0-9]*$/.test(value)),
    bankAccountNumber: yup
      .string()
      .required('This field is required')
      .min(10, 'Must have 10-34 characters')
      .max(34, 'Must have 10-34 characters')
      // eslint-disable-next-line
      .test('isLatinLetters', 'Latin letters, and numbers only', (value: any): boolean => /^[a-zA-Z0-9]*$/.test(value)),
    referenceToInclude: yup
      .string()
      .notRequired()
      .nullable()
      .when('referenceToInclude', {
        is: (value: string) => value?.length,
        then: (rule) =>
          rule
            .min(5, 'Must have from 5 to 50 characters')
            .max(50, 'Must have from 5 to 50 characters')
            // eslint-disable-next-line
            .test('isLatinLetters', 'Latin letters, and numbers only', (value: any): boolean =>
              /^[a-zA-Z0-9!@#$%^&*\s()_+\-=[\]{};':"\\|,.<>/?]*$/.test(value),
            ),
      }),
    intermediaryBankName: yup
      .string()
      .notRequired()
      .nullable()
      .when('intermediaryBankName', {
        is: (value: string) => value?.length,
        then: (rule) =>
          rule
            .min(2, 'Must have at least 2 characters')
            // eslint-disable-next-line
            .test('isLatinLetters', 'Latin letters, and numbers only', (value: any): boolean =>
              /^[a-zA-Z0-9!@#$%^&*\s()_+\-=[\]{};':"\\|,.<>/?]*$/.test(value),
            ),
      }),
    intermediaryBankSwiftBic: yup
      .string()
      .notRequired()
      .nullable()
      .when('intermediaryBankSwiftBic', {
        is: (value: string) => value?.length,
        then: (rule) =>
          rule
            .min(8, 'Must have 8-11 characters')
            .max(11, 'Must have 8-11 characters')
            // eslint-disable-next-line
            .test('isLatinLetters', 'Latin letters, and numbers only', (value: any): boolean =>
              /^[a-zA-Z0-9!@#$%^&*\s()_+\-=[\]{};':"\\|,.<>/?]*$/.test(value),
            ),
      }),
    intermediaryBankAddress: yup
      .string()
      .notRequired()
      .nullable()
      .when('intermediaryBankAddress', {
        is: (value: string) => value?.length,
        then: (rule) =>
          rule
            .min(5, 'Must have from 5 to 50 characters')
            .max(50, 'Must have from 5 to 50 characters')
            // eslint-disable-next-line
            .test('isLatinLetters', 'Latin letters, and numbers only', (value: any): boolean =>
              /^[a-zA-Z0-9!@#$%^&*\s()_+\-=[\]{};':"\\|,.<>/?]*$/.test(value),
            ),
      }),
  },
  [
    ['description', 'description'],
    ['referenceToInclude', 'referenceToInclude'],
    ['intermediaryBankName', 'intermediaryBankName'],
    ['intermediaryBankSwiftBic', 'intermediaryBankSwiftBic'],
    ['intermediaryBankAddress', 'intermediaryBankAddress'],
  ],
)

export const resolverFiat = yupResolver(Schema)
